/**
 * News Component: Manages filtering, loading, and displaying news entries via category and tags.
 */
app.components.news = {
    onReady() {
        return !!document.querySelector('.news');
    },

    addListener() {
        this.initializeCategoryToggle();
        this.initializeTags();
        this.initializeLoadButton();

        const hash = window.location.hash;
        if (hash && document.querySelector(hash)) {
            document.querySelector(hash).click();
        }
    },

    initializeCategoryToggle() {
        const toggle = document.getElementById('category-toggle');
        if (!toggle) {
            return;
        }

        toggle.addEventListener('change', (event) => {
            const el = event.target;
            const {component, template, on: onCategory, off: offCategory} = el.dataset;
            const category = el.checked ? onCategory : offCategory;
            const term = 0;
            console.log('Category changed to:', category);
            this.updateSwitchLabel(category);
            this.getNewsEntries(component, template, category, term);
            this.getTags(category, 1);
        });
    },

    updateSwitchLabel(category) {
        const labels = document.querySelectorAll('.switch-labels span[data-category]');
        labels.forEach(label => {
            label.classList.remove('active');
            if (label.dataset.category === String(category)) {
                label.classList.add('active');
            }
        });
    },

    initializeTags() {
        const tagButtons = document.querySelectorAll('.news__filter__tags button.tag');
        tagButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const {component, template, category, term, href} = button.dataset;
                button.parentElement.querySelectorAll('button.tag').forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');
                history.pushState({}, "", href);
                this.getNewsEntries(component, template, category, term);
            });
        });

        document.querySelectorAll('.news__filter__tags button.tag i.icon-close').forEach((icon) => {
            icon.addEventListener('click', (event) => {
                event.stopPropagation();

                const button = icon.closest('button.tag');
                const {component, template} = button.dataset;
                const category = 0;
                const term = 0;

                const allNewsTag = document.querySelector('.news__filter__tags button.tag[data-term="0"]');
                if (allNewsTag) {
                    allNewsTag.classList.add('active');
                    history.pushState({}, "", allNewsTag.dataset.href);
                }

                button.classList.remove('active');
                this.getNewsEntries(component, template, category, term);
            });
        });
    },

    initializeLoadButton() {
        const loadBtn = $('.news button.load');
        if (!loadBtn.length) return;

        const posts = $('.news__container teaser-component');
        let visibleCount =0;
        const postsPerLoad = 12; // posts per page

        function showNextPosts() {
            const nextPosts = posts.slice(visibleCount, visibleCount + postsPerLoad);
            nextPosts.show();
            visibleCount += postsPerLoad;

            if (visibleCount >= posts.length) {
                loadBtn.fadeOut();
            }
        }
        posts.hide(); // init hide
        showNextPosts();

        loadBtn.off('click').on('click', function () {
            const button = $(this);
            if (button.hasClass('loading')) return;

            button.addClass('loading');

            setTimeout(() => {
                showNextPosts();
                button.removeClass('loading');
            }, 25);
        });
    },

    getNewsEntries(component, template, category, term) {
        const that = this;
        const $container = $('.news').eq(0);
        $container.addClass('loading');

        const options = ['template:' + template, 'category:' + category, 'term:' + term];
        const endpoint = '?component=' + component + '&options=' + options.join(';');

        const button = $('button.load', $container);
        button.data('category', category);
        button.data('term', term);
        button.attr('disabled', 'disabled');
        button.fadeIn(250);

        $.get(endpoint, function (data) {
            if (data) {
                $('.news__container', $container).html(data);
                button.prop("disabled", true).removeAttr("disabled");
            } else {
                button.fadeOut(250);
            }
            $container.removeClass('loading');
            that.initializeLoadButton();
        });
    },

    getTags(category) {
        const tagContainer = document.querySelector('.news__filter__tags');
        if (!tagContainer) return;

        const that = this;
        const component = 'news';
        const template = 'filter_tags';
        const term = 0;
        const options = [`template:${template}`, `category:${category}`, `term:${term}`, `show_filter:1`];
        const endpoint = `?component=${component}&options=${options.join(';')}`;

        $.get(endpoint, (response) => {
            if (!response) return;
            tagContainer.innerHTML = response;
            that.initializeTags();
        });
    }
};
